import type { TOC } from '@ember/component/template-only';
import GeneralDayDetailDayDetail from 'lumen/components/general/day-detail/day-detail';
import type MarketMarketratesDetailController from 'lumen/controllers/market/marketrates/detail';

interface MarketMarketratesDetailSignature {
  Args: {
    controller: MarketMarketratesDetailController;
    model: unknown;
  };
}

<template>
  <GeneralDayDetailDayDetail
    @activeCompset={{@controller.activeCompset}}
    @changeDay={{@controller.changeDay}}
    @currentHotel={{@controller.hotel}}
    {{! @glint-expect-error: Incorrect type }}
    @date={{@controller.date}}
    {{! @glint-expect-error: Incorrect type }}
    @isRedirected={{true}}
    @model={{@controller.model}}
    @offset={{@controller.offset}}
    @otaId={{@controller.otaId}}
    @ratesParams={{@controller.ratesParams}}
    @redirect={{@controller.redirect}}
    @selectedOTA={{@controller.selectedOTA}}
    @type={{@controller.type}}
    @updateOffset={{@controller.updateOffset}}
    @updateType={{@controller.updateType}}
  />
</template> satisfies TOC<MarketMarketratesDetailSignature>;
